import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// Route level code-splitting with lazy loading
const HomePage = () =>
  import(/* webpackChunkName: "home" */ '../views/home/Home.vue');
const SolutionsMakerSpace = () =>
  import(
    /* webpackChunkName: "solutions" */ '../views/solutions/MakerSpace.vue'
  );
const SolutionsStem = () =>
  import(/* webpackChunkName: "solutions" */ '../views/solutions/Stem.vue');
const AboutUsPage = () =>
  import(/* webpackChunkName: "about" */ '../views/about/AboutUs.vue');
const BecomeDealer = () =>
  import(/* webpackChunkName: "about" */ '../views/about/BecomeDealer.vue');
const CooperationPage = () =>
  import(/* webpackChunkName: "about" */ '../views/about/Cooperation.vue');
const AboutNewsPage = () =>
  import(/* webpackChunkName: "about" */ '../views/about/AboutNews.vue');
const NewsDetailPage = () =>
  import(/* webpackChunkName: "about" */ '../views/about/NewsDetail.vue');
const AfterSalesSupportPage = () =>
  import(/* webpackChunkName: "support" */ '../views/support/AfterSales.vue');
const SoftwarePage = () =>
  import(/* webpackChunkName: "software" */ '../views/software/Software.vue');
const ProductMain = () =>
  import(/* webpackChunkName: "products" */ '../views/product/Product.vue');
const ProductLaser = () =>
  import(/* webpackChunkName: "products" */ '../views/product/Laser.vue');
const ProductFarm = () =>
  import(/* webpackChunkName: "products" */ '../views/product/Farm.vue');
const ProductSmartHome = () =>
  import(/* webpackChunkName: "products" */ '../views/product/SmartHome.vue');
const ProductSmartTraffic = () =>
  import(
    /* webpackChunkName: "products" */ '../views/product/SmartTraffic.vue'
  );
const ProductSmartFactory = () =>
  import(
    /* webpackChunkName: "products" */ '../views/product/SmartFactory.vue'
  );
const ProductLaserSteamKit = () =>
  import(
    /* webpackChunkName: "products" */ '../views/product/LaserSteamKit.vue'
  );
const ProductDreamScienceKit = () =>
  import(
    /* webpackChunkName: "products" */ '../views/product/DreamScienceKit.vue'
  );
const ProductKitsViewAll = () =>
  import(/* webpackChunkName: "products" */ '../views/product/KitsViewAll.vue');
const ProductCourses = () =>
  import(
    /* webpackChunkName: "products" */ '../views/product/CoursesOverview.vue'
  );
const ThankYouPage = () =>
  import(/* webpackChunkName: "thank-you" */ '../views/ThankYou.vue');

export default new Router({
  mode: 'history',
  // 保持用户滚动位置：不在导航时自动回到顶部
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return null;
  },
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
      meta: {
        title: 'Home',
        metaTags: [
          {
            name: 'description',
            content: 'Welcome to our marketing website built with Vue.js',
          },
          {
            name: 'keywords',
            content: 'marketing, vue2, seo, website',
          },
        ],
      },
    },
    {
      path: '/products',
      name: 'Products',
      component: ProductMain,
      children: [
        {
          path: 'laser',
          name: 'ProductLaser',
          component: ProductLaser,
        },
        {
          path: 'laser-steam',
          name: 'ProductLaserSteamKit',
          component: ProductLaserSteamKit,
        },
        {
          path: 'home',
          name: 'ProductSmartHome',
          component: ProductSmartHome,
        },
        {
          path: 'traffic',
          name: 'ProductSmartTraffic',
          component: ProductSmartTraffic,
        },
        {
          path: 'factory',
          name: 'ProductSmartFactory',
          component: ProductSmartFactory,
        },
        {
          path: 'dream-science',
          name: 'ProductDreamScienceKit',
          component: ProductDreamScienceKit,
        },
        {
          path: 'course',
          name: 'ProductCourses',
          component: ProductCourses,
        },
        {
          path: 'kits',
          name: 'ProductKitsViewAll',
          component: ProductKitsViewAll,
        },
        {
          path: 'farm',
          name: 'ProductFarm',
          component: ProductFarm,
        },
        {
          path: 'device',
          redirect: 'laser',
        },
      ],
    },
    {
      path: '/solutions/maker-space',
      name: 'SolutionsMakerSpace',
      component: SolutionsMakerSpace,
    },
    {
      path: '/solutions/stem',
      name: 'SolutionsStem',
      component: SolutionsStem,
    },
    {
      path: '/software',
      name: 'Software',
      component: SoftwarePage,
    },
    {
      path: '/about',
      name: 'AboutUs',
      component: AboutUsPage,
    },
    {
      path: '/about/cooperation',
      name: 'Cooperation',
      component: CooperationPage,
    },
    {
      path: '/about/news',
      name: 'AboutNews',
      component: AboutNewsPage,
    },
    {
      path: '/about/news/:id',
      name: 'NewsDetail',
      component: NewsDetailPage,
    },
    {
      path: '/about/dealer',
      name: 'BecomeDealer',
      component: BecomeDealer,
    },
    {
      path: '/support/after-sale',
      name: 'AfterSalesSupport',
      component: AfterSalesSupportPage,
    },
    {
      path: '/thank-you',
      name: 'ThankYou',
      component: ThankYouPage,
    },
  ],
});
